import React from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
import { useSelector } from "react-redux"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  permission,
  ...rest
}: any) => {
  const selected = useSelector((state: any) => state.factory && state.factory.selected)
  const perms: string[] = (selected && selected.permission) || []
  const isAdmin = perms.includes("ADMIN")

  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthProtected && !localStorage.getItem("token")) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          )
        }

        // Permission gate: once a factory is loaded, block direct navigation to a
        // page the user has no permission for (admins bypass). While no factory is
        // loaded yet (selected null) we don't redirect — the page guards itself.
        if (
          isAuthProtected &&
          permission &&
          selected &&
          !isAdmin &&
          !perms.includes(permission)
        ) {
          return (
            <Redirect
              to={{ pathname: "/dashboard", state: { from: props.location } }}
            />
          )
        }

        if(!isAuthProtected && ['/login'].includes(props.location.pathname) && localStorage.getItem("token")) {
          return (
            <Redirect
              to={{ pathname: "/dashboard", state: { from: props.location } }}
            />
          )
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        )
      }}
    />
  )
}


export default Authmiddleware;
